import React from 'react';

/** Web top navigation: logo + stacked wordmark, links, right-side actions. Sticky. */
export function TopNav({ logo, links = [], activeId, onNavigate, onLogoClick, right, className = '' }) {
  return (
    <header className={`bjl-topnav ${className}`}>
      <span className="bjl-topnav__brand" onClick={onLogoClick}>
        {logo ? <img className="bjl-topnav__logo" src={logo} alt="边角聊 logo" /> : null}
        <span className="bjl-topnav__wordmark">
          <b>边角聊</b>
          <span>LEFTOVER TALK</span>
        </span>
      </span>
      <nav className="bjl-topnav__links">
        {links.map((l) => (
          <button
            key={l.id}
            className={`bjl-topnav__link ${l.id === activeId ? 'is-active' : ''}`}
            onClick={() => onNavigate && onNavigate(l.id)}
          >
            {l.label}
          </button>
        ))}
      </nav>
      <span className="bjl-topnav__right">{right}</span>
    </header>
  );
}
